import { render, staticRenderFns } from "./OnlineTrainingList.vue?vue&type=template&id=096f22ef"
import script from "./OnlineTrainingList.vue?vue&type=script&lang=js"
export * from "./OnlineTrainingList.vue?vue&type=script&lang=js"
import style0 from "./OnlineTrainingList.vue?vue&type=style&index=0&id=096f22ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports